import { Box, Paper } from '@mui/material'
import React from 'react'

function DependencyGrid({
    tableData = [],
    onEdit,
    onDelete,
    onVariants,
    page, 
    rowsPerPage,
    totalPages,
    onPageChange,
    onRowsPerPageChange,
    isLoading,
}) {
  return (
    <Box sx={{ width: "100%" }} component={Paper}>
        <Box
            sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                width: "100%",
                fontSize: "4rem"
            }}
        >
            En Desarrollo...
        </Box>
    </Box>
  )
}

export default DependencyGrid